// extracted by mini-css-extract-plugin
module.exports = {"link":"SiteLink_link__POVwE","small":"SiteLink_small__nEMAM"};